/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Invoice_Status_PendingInputs */



/**
* | output |
* | --- |
* | "Pending creation" |
*
* @param {Partner_Admin_Invoice_Status_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_invoice_status_pending = /** @type {((inputs?: Partner_Admin_Invoice_Status_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Invoice_Status_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellung ausstehend")
	return /** @type {LocalizedString} */ ("Pending creation")
});